import type { RootState } from '..';
import { isOidcAuth } from '../../config/featureFlags';

const hasRole = (role: unknown, expectedRole: string) => {
  if (isOidcAuth()) {
    return Array.isArray(role) && role.includes(expectedRole);
  }

  return role === expectedRole;
};

export const selectAuthUser = (state: RootState) => state.auth.user;

export const selectIsPlatformAdmin = (state: RootState) =>
  hasRole(state.auth.user?.role, 'ADMIN');

export const selectIsSuperAdmin = (state: RootState) =>
  hasRole(state.auth.user?.role, 'SUPER_ADMIN');

export const selectIsUserRole = (state: RootState) =>
  hasRole(state.auth.user?.role, 'USER');
